import React from 'react';
import { Hero } from './components/AcquireFlowHero';
import { Testimonial } from './components/AcquireFlowHerovideo';
import { Testimonials } from './components/AcquireFlowTestimonials';
import { FounderStory } from './components/AcquireFounderStory';
import { FAQSection } from './components/AcquireFAQSection';
import { SecurityCTA } from './components/AcquireFlowSecurityCTA';
import { Footer } from './components/AcquireFooter';
import { SEOHead } from './components/SEO/SEOHead';
import { CurvedDivider, ScrollProgress, ActivityNotification } from './components/shared';
import { CalendarModalProvider } from './components/shared/CalendarModalContext';
import { generateHomepageSchema } from './utils/structuredData';
// Import data
import { testimonials } from './data/testimonials';
export function App() {
  return <CalendarModalProvider data-id="element-0">
      {/* SEO Meta Tags and Structured Data */}
      <SEOHead structuredData={generateHomepageSchema()} data-id="element-1" />

      {/* Scroll Progress Indicator */}
      <ScrollProgress data-id="element-2" />

      {/* Activity Notification Popup */}
      <ActivityNotification data-id="element-3" />

      <div className="flex flex-col min-h-screen" data-id="element-4">
        {/* Centered Logo Header */}
        <div className="w-full bg-[#121212] py-5 flex justify-center" data-id="element-5">
          <a href="/" aria-label="AcquireFlow Home" data-id="element-6">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dxuXv5AoswiCCU7F4ucVPA/AcquireFlow_Logo_%287%29.svg" alt="AcquireFlow" className="h-10 md:h-12" data-id="element-7" />
          </a>
        </div>
        <main className="flex-grow" data-id="element-8">
          {/* Hero Section - Dark Background */}
          <section className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-9">
            <Hero data-id="element-10" />
          </section>

          {/* Curved Divider: Dark to Light */}
          <CurvedDivider direction="dark-to-light" data-id="element-11" />

          {/* Success Stories Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-12">
            <Testimonials title="Success Stories" subtitle="What Says Our Clients" description="Join 200+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience." testimonials={testimonials} data-id="element-13" />
          </section>

          {/* Founder Story Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-14">
            <FounderStory data-id="element-15" />
          </section>

          {/* FAQ Section - Light Background */}
          <section className="relative w-full bg-[#fafafa] overflow-hidden" data-id="element-16">
            <FAQSection data-id="element-17" />
          </section>

          {/* Curved Divider: Light to Dark */}
          <CurvedDivider direction="light-to-dark" data-id="element-18" />

          {/* Security CTA Section - Dark Background */}
          <section className="relative w-full bg-gradient-to-b from-[#121212] via-[#0f0f0f] to-[#121212] overflow-hidden" data-id="element-19">
            <SecurityCTA data-id="element-20" />
          </section>
        </main>
        <Footer data-id="element-21" />
      </div>
    </CalendarModalProvider>;
}